"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function default_1() {
    const fakeChunkedArr = [
        [0, 0, 0, 0],
        [0, 0, 0],
    ];
    // ? products_list, list_slide at ProductsListWrapper
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "horizontal_drag_scroll", id: "products_list", css: { cursor: 'unset' } }, { children: fakeChunkedArr.map((chunk, chunkIdx) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "list_slide", css: { width: '82%' } }, { children: chunk.map((_, chunkedSkeletonIndex) => ((0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: { width: '100%', height: '64px', borderRadius: '4px 4px 24px' } }, `skeleton_bar_${chunkIdx}_${chunkedSkeletonIndex}`))) }), `chunked_skeleton_${chunkIdx}`))) })));
}
exports.default = default_1;
